export const TRANSLATION_PREFIX = 'administration.surveyBank'

export const DEFAULT_PER_PAGE = 10

/** Rows the course block picker shows; it searches instead of paginating. */
export const PICKER_PAGE_SIZE = 50
